import { useState } from "react";
import {
    createFinanceDeductibleAsync,
    deleteFinanceDeductibleAsync,
    disableFinanceDeductibleAsync,
    enableFinanceDeductibleAsync,
    reorderFinanceDeductiblesAsync,
    updateFinanceDeductibleAsync,
} from "@features/admin/finance/deductible/services/financeDeductibleSvc";
import { SaveFinanceDeductibleRequest } from "@features/admin/finance/deductible/types/financeDeductible";

export function useFinanceDeductibleAction() {
    const [busy, setBusy] = useState(false);

    const run = async <T,>(fn: () => Promise<T>): Promise<T> => {
        setBusy(true);
        try {
            return await fn();
        } finally {
            setBusy(false);
        }
    };

    const doCreate = (nationId: number, data: SaveFinanceDeductibleRequest) =>
        run(() => createFinanceDeductibleAsync(nationId, data));

    const doUpdate = (nationId: number, deductibleId: number, data: SaveFinanceDeductibleRequest) =>
        run(() => updateFinanceDeductibleAsync(nationId, deductibleId, data));

    const doDisable = (nationId: number, deductibleId: number) =>
        run(() => disableFinanceDeductibleAsync(nationId, deductibleId));

    const doEnable = (nationId: number, deductibleId: number, resolveConflicts: boolean) =>
        run(() => enableFinanceDeductibleAsync(nationId, deductibleId, resolveConflicts));

    const doDelete = (nationId: number, deductibleId: number) =>
        run(() => deleteFinanceDeductibleAsync(nationId, deductibleId));

    const doReorder = (nationId: number, deductibleIds: number[]) =>
        run(() => reorderFinanceDeductiblesAsync(nationId, deductibleIds));

    return { busy, doCreate, doUpdate, doDisable, doEnable, doDelete, doReorder };
}
